import { Link } from "react-router-dom";
import { GraduationCap, ArrowRight, Target, Clock, Users2, TrendingUp } from "lucide-react";
import { Button } from "../components/ui/button";
import { PageHero, Reveal, SectionHeading } from "../components/common";
import { TESTS } from "../mock";

const FEATURES = [
  { icon: Users2, title: "Small-batch coaching", desc: "Personalised attention with limited seats per batch for real progress." },
  { icon: Clock, title: "Real timed mocks", desc: "Full-length simulations scored to the official rubric of each exam." },
  { icon: Target, title: "Score targets", desc: "Goals set against the universities on your actual shortlist." },
  { icon: TrendingUp, title: "Proven strategies", desc: "Experienced faculty share section-wise tactics that lift scores fast." },
];

export default function TestPrep() {
  return (
    <>
      <PageHero
        eyebrow="Test Prep"
        title="Clear the exam before you clear the visa"
        subtitle="Expert coaching for IELTS, TOEFL, PTE and GRE — with real mocks, personalised feedback and a score-target roadmap."
        image="https://images.unsplash.com/photo-1576495199011-eb94736d05d6"
      />
      <section className="section-pad bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <SectionHeading eyebrow="Exams We Coach" title="Expert coaching for your dream university" subtitle="Personalised test preparation with experienced faculty and proven strategies." />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
            {TESTS.map((t, i) => (
              <Reveal key={t.code} delay={i * 60}>
                <div className="rounded-2xl p-7 text-white h-full hover-lift" style={{ backgroundColor: t.color }}>
                  <GraduationCap size={28} className="text-[#e0c05a]" />
                  <h3 className="font-display text-2xl font-bold mt-4">{t.name}</h3>
                  <p className="text-white/70 text-sm mt-2.5 leading-relaxed">{t.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad bg-[#f4f8f6]">
        <div className="max-w-7xl mx-auto px-6">
          <SectionHeading eyebrow="Why Our Coaching Works" title="A prep plan with an actual calendar" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
            {FEATURES.map((f, i) => (
              <Reveal key={f.title} delay={i * 70}>
                <div className="bg-white rounded-2xl p-7 border border-slate-100 h-full hover-lift">
                  <div className="w-13 h-13 w-14 h-14 rounded-xl bg-[#f0f6f3] grid place-items-center text-[#004030]"><f.icon size={24} /></div>
                  <h3 className="font-semibold text-[#012a1e] text-lg mt-4">{f.title}</h3>
                  <p className="text-slate-500 text-sm mt-1.5 leading-relaxed">{f.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="text-center mt-14">
            <Link to="/contact"><Button className="bg-[#004030] hover:bg-[#013d2b] text-white rounded-full h-12 px-8 font-semibold">Book a free demo class <ArrowRight size={17} className="ml-1" /></Button></Link>
          </div>
        </div>
      </section>
    </>
  );
}